import React, { useState, useRef } from "react";
import Card from "../../../modules/Card";
import PasswordToggle from "../../../modules/PasswordToggle";
import Spinner from "../../../modules/Spinner";
import { useTranslation } from "react-i18next";

const PasswordInputScreen = ({ onNext, isLoading }) => {
  const [error, setError] = useState(undefined);

  const passwordRef = useRef();
  const confirmPasswordRef = useRef();
  const { t } = useTranslation();

  const handleSubmit = () => {
    const letter = /[a-z]/;
    const number = /[0-9]/;

    const password = passwordRef.current.value;
    const confirmPassword = confirmPasswordRef.current.value;

    if (
      !letter.test(password.toLowerCase()) ||
      !number.test(password) ||
      password.legnth < 4
    ) {
      setError(t("password_validation"));
      return;
    }

    if (password === confirmPassword) {
      onNext(password);
    } else {
      setError(t("password_doesnt_match"));
    }
  };

  return (
    <div className=" px-6 mt-10 ">
      <div className="flex flex-col items-center gap-0.5 justify-center">
        <p className="font-custom  text-2xl font-semibold text-[#7953D2] ">
          {t("create_password")}!
        </p>
        <p className="font-custom text-sm text-xs font-medium text-dark_gray ">
          {t("set_new_password")}
        </p>
      </div>

      <Card>
        <div className="flex flex-col gap-5">
          <PasswordToggle
            label={t("password")}
            placeholder={t("enter_password")}
            ref={passwordRef}
          />
          <PasswordToggle
            label={t("confirm_password")}
            placeholder={t("enter_password_again")}
            ref={confirmPasswordRef}
          />
        </div>

        <div className="mt-2">
          {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
        </div>

        <div className="mt-8">
          <button
            onClick={handleSubmit}
            className="font-custom btn btn-block bg-[#492897] text-white rounded-[30px] text-base font-semibold"
          >
            {isLoading ? (
              <Spinner heightResponsive />
            ) : (
              <span>{t("set_password")}</span>
            )}
          </button>
        </div>
      </Card>
    </div>
  );
};

export default PasswordInputScreen;
